import { useEffect, useRef, useState } from 'react';

export const getBase64imagePlaceholder = (index: number) => `placeholder://IMG${index}`;

const mimeSignatures = {
  JVBERi0: 'application/pdf',
  R0lGODdh: 'image/gif',
  R0lGODlh: 'image/gif',
  iVBORw0KGgo: 'image/png',
  '/9j/': 'image/jpg',
  Qk02U: 'image/bmp',
};

export const getMimeType = (base64 = ''): string => {
  const foundSignature = Object.entries(mimeSignatures).find(([signature]) => base64.startsWith(signature));
  return (foundSignature && foundSignature[1]) || 'image/png';
};

export const getFilledHtmlContentImagePlaceholders = (htmlContent: string, images: string[]) => {
  return images.reduce((result: string, image: string, index: number) => {
    const imageUrl = image.startsWith('data:') ? image : `data:${getMimeType(image)};base64,${image}`;
    return result.replaceAll(getBase64imagePlaceholder(index), imageUrl);
  }, htmlContent);
};

function useBase64Images(htmlContent: string) {
  const [htmlContentWithoutImages, setHtmlContentWithoutImages] = useState<string>('');
  const base64imagesFromHtmlContent = useRef<string[]>([]);

  useEffect(() => {
    const html = new DOMParser().parseFromString(htmlContent, 'text/html');
    const base64Images = [...html.images]
      .filter((item) => item.src.includes('base64'))
      .map((e) => e.src);

    base64imagesFromHtmlContent.current = base64Images;
    
    const result = base64imagesFromHtmlContent.current.reduce((prevResult, image, index) => {
      if (image.includes('base64')) {
        return prevResult.replace(image, getBase64imagePlaceholder(index));
      }
      return prevResult;
    }, htmlContent);
    setHtmlContentWithoutImages(window.btoa(encodeURIComponent(result)));
  }, [htmlContent]);

  return { htmlContentWithoutImages, images: base64imagesFromHtmlContent.current };
}

export default useBase64Images;
